<template>
  <RecurrenceDialog
    :schedule="schedule"
    :subtitle="playlist?.playlist?.name"
    :allow-inherit-dates="true"
    inherit-dates-label="Same as campaign"
    @save="onSave"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import RecurrenceDialog, { type RecurrenceSchedule } from '@/components/RecurrenceDialog/RecurrenceDialog.vue';

const emit = defineEmits(['cancel', 'save', 'exit', 'fail']);
const props = defineProps({
  campaignTitle: { type: String, default: '' },
  playlist:      { type: Object, default: null },
});

const schedule = computed<RecurrenceSchedule>(() => ({
  weekdays:  props.playlist?.weekdays  ?? 127,
  startTime: props.playlist?.startTime ?? '00:00:00',
  endTime:   props.playlist?.endTime   ?? '23:59:59',
  startDate: props.playlist?.startDate ?? null,
  endDate:   props.playlist?.endDate   ?? null,
}));

function onSave(newSchedule: RecurrenceSchedule) {
  emit('save', newSchedule);
}
</script>
